/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PartialProfitabilityData } from './PartialProfitabilityData';
import {
    PartialProfitabilityDataFromJSON,
    PartialProfitabilityDataFromJSONTyped,
    PartialProfitabilityDataToJSON,
    PartialProfitabilityDataToJSONTyped,
} from './PartialProfitabilityData';
import type { NullableMoneyOutput } from './NullableMoneyOutput';
import {
    NullableMoneyOutputFromJSON,
    NullableMoneyOutputFromJSONTyped,
    NullableMoneyOutputToJSON,
    NullableMoneyOutputToJSONTyped,
} from './NullableMoneyOutput';
import type { MediaSourceQuality } from './MediaSourceQuality';
import {
    MediaSourceQualityFromJSON,
    MediaSourceQualityFromJSONTyped,
    MediaSourceQualityToJSON,
    MediaSourceQualityToJSONTyped,
} from './MediaSourceQuality';
import type { MarketingChannelOverviewItemData } from './MarketingChannelOverviewItemData';
import {
    MarketingChannelOverviewItemDataFromJSON,
    MarketingChannelOverviewItemDataFromJSONTyped,
    MarketingChannelOverviewItemDataToJSON,
    MarketingChannelOverviewItemDataToJSONTyped,
} from './MarketingChannelOverviewItemData';
import type { PrecalculationSnapshotReadMetadata } from './PrecalculationSnapshotReadMetadata';
import {
    PrecalculationSnapshotReadMetadataFromJSON,
    PrecalculationSnapshotReadMetadataFromJSONTyped,
    PrecalculationSnapshotReadMetadataToJSON,
    PrecalculationSnapshotReadMetadataToJSONTyped,
} from './PrecalculationSnapshotReadMetadata';

/**
 * 
 * @export
 * @interface MarketingChannelOverviewCollectionData
 */
export interface MarketingChannelOverviewCollectionData {
    /**
     * 
     * @type {Array<MarketingChannelOverviewItemData>}
     * @memberof MarketingChannelOverviewCollectionData
     */
    items?: Array<MarketingChannelOverviewItemData>;
    /**
     * 
     * @type {PrecalculationSnapshotReadMetadata}
     * @memberof MarketingChannelOverviewCollectionData
     */
    snapshot?: PrecalculationSnapshotReadMetadata;
    /**
     * 
     * @type {PartialProfitabilityData}
     * @memberof MarketingChannelOverviewCollectionData
     */
    partialProfitability?: PartialProfitabilityData | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof MarketingChannelOverviewCollectionData
     */
    globalTurnoverNet?: NullableMoneyOutput | null;
    /**
     * 
     * @type {number}
     * @memberof MarketingChannelOverviewCollectionData
     */
    globalOrderCountCompleted?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof MarketingChannelOverviewCollectionData
     */
    selectedCentreSpendAttributionComplete?: boolean | null;
    /**
     * 
     * @type {PartialProfitabilityData}
     * @memberof MarketingChannelOverviewCollectionData
     */
    partialProfitabilityMarketing?: PartialProfitabilityData | null;
    /**
     * 
     * @type {NullableMoneyOutput}
     * @memberof MarketingChannelOverviewCollectionData
     */
    globalTurnoverMarketing?: NullableMoneyOutput | null;
    /**
     * 
     * @type {number}
     * @memberof MarketingChannelOverviewCollectionData
     */
    globalOrderCountMarketing?: number | null;
    /**
     * 
     * @type {MediaSourceQuality}
     * @memberof MarketingChannelOverviewCollectionData
     */
    mediaSourceQuality?: MediaSourceQuality;
    /**
     * 
     * @type {MarketingChannelOverviewCollectionDataFinanceScopeEnum}
     * @memberof MarketingChannelOverviewCollectionData
     */
    financeScope?: MarketingChannelOverviewCollectionDataFinanceScopeEnum;
}


/**
 * @export
 */
export const MarketingChannelOverviewCollectionDataFinanceScopeEnum = {
    CanonicalSelected: 'canonical_selected'
} as const;
export type MarketingChannelOverviewCollectionDataFinanceScopeEnum = typeof MarketingChannelOverviewCollectionDataFinanceScopeEnum[keyof typeof MarketingChannelOverviewCollectionDataFinanceScopeEnum];


/**
 * Check if a given object implements the MarketingChannelOverviewCollectionData interface.
 */
export function instanceOfMarketingChannelOverviewCollectionData(value: object): value is MarketingChannelOverviewCollectionData {
    return true;
}

export function MarketingChannelOverviewCollectionDataFromJSON(json: any): MarketingChannelOverviewCollectionData {
    return MarketingChannelOverviewCollectionDataFromJSONTyped(json, false);
}

export function MarketingChannelOverviewCollectionDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketingChannelOverviewCollectionData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(MarketingChannelOverviewItemDataFromJSON)),
        'snapshot': json['snapshot'] == null ? undefined : PrecalculationSnapshotReadMetadataFromJSON(json['snapshot']),
        'partialProfitability': json['partialProfitability'] === undefined ? undefined : json['partialProfitability'] === null ? null : PartialProfitabilityDataFromJSON(json['partialProfitability']),
        'globalTurnoverNet': json['globalTurnoverNet'] === undefined ? undefined : json['globalTurnoverNet'] === null ? null : NullableMoneyOutputFromJSON(json['globalTurnoverNet']),
        'globalOrderCountCompleted': json['globalOrderCountCompleted'] === undefined ? undefined : json['globalOrderCountCompleted'] === null ? null : json['globalOrderCountCompleted'],
        'selectedCentreSpendAttributionComplete': json['selectedCentreSpendAttributionComplete'] === undefined ? undefined : json['selectedCentreSpendAttributionComplete'] === null ? null : json['selectedCentreSpendAttributionComplete'],
        'partialProfitabilityMarketing': json['partialProfitabilityMarketing'] === undefined ? undefined : json['partialProfitabilityMarketing'] === null ? null : PartialProfitabilityDataFromJSON(json['partialProfitabilityMarketing']),
        'globalTurnoverMarketing': json['globalTurnoverMarketing'] === undefined ? undefined : json['globalTurnoverMarketing'] === null ? null : NullableMoneyOutputFromJSON(json['globalTurnoverMarketing']),
        'globalOrderCountMarketing': json['globalOrderCountMarketing'] === undefined ? undefined : json['globalOrderCountMarketing'] === null ? null : json['globalOrderCountMarketing'],
        'mediaSourceQuality': json['mediaSourceQuality'] == null ? undefined : MediaSourceQualityFromJSON(json['mediaSourceQuality']),
        'financeScope': json['financeScope'] == null ? undefined : json['financeScope'],
    };
}

export function MarketingChannelOverviewCollectionDataToJSON(json: any): MarketingChannelOverviewCollectionData {
    return MarketingChannelOverviewCollectionDataToJSONTyped(json, false);
}

export function MarketingChannelOverviewCollectionDataToJSONTyped(value?: MarketingChannelOverviewCollectionData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(MarketingChannelOverviewItemDataToJSON)),
        'snapshot': PrecalculationSnapshotReadMetadataToJSON(value['snapshot']),
        'partialProfitability': PartialProfitabilityDataToJSON(value['partialProfitability']),
        'globalTurnoverNet': NullableMoneyOutputToJSON(value['globalTurnoverNet']),
        'globalOrderCountCompleted': value['globalOrderCountCompleted'],
        'selectedCentreSpendAttributionComplete': value['selectedCentreSpendAttributionComplete'],
        'partialProfitabilityMarketing': PartialProfitabilityDataToJSON(value['partialProfitabilityMarketing']),
        'globalTurnoverMarketing': NullableMoneyOutputToJSON(value['globalTurnoverMarketing']),
        'globalOrderCountMarketing': value['globalOrderCountMarketing'],
        'mediaSourceQuality': MediaSourceQualityToJSON(value['mediaSourceQuality']),
        'financeScope': value['financeScope'],
    };
}

